import { RootAppState } from 'store/configureStore'

export const projectQuotationDateSelector = (state: RootAppState) => {
  return state.project.activeProject?.quotationDate
}
